<template>
  <div>
    <section class="uk-margin">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link to="/admin">Администрирование</router-link>
          </li>
          <li class="is-active">
            <a href="#">Компании</a>
          </li>
          <li>
            <a href="#" @click.prevent="add()">Добавить</a>
          </li>
        </ul>
      </nav>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
    <section class="uk-margin">
      <b-field grouped group-multiline>
        <b-field label="Сортировка">
          <b-select v-model="filters.order" @input="pageChange()">
            <option value="asc">Восходящая (ASC)</option>
            <option value="desc">Нисходящая (DESC)</option>
          </b-select>
        </b-field>
        <b-field label="На страницу">
          <b-select v-model="filters.limit" @input="pageChange()">
            <option
              v-for="option in limits"
              :value="option"
              :key="option">
              {{ option }} шт.
            </option>
          </b-select>
        </b-field>
        <b-field label="Поиск компании">
          <b-field>
            <b-autocomplete
              :data="async_data"
              :placeholder="search_placeholder"
              field="search"
              :loading="isFetching"
              @typing="getAsyncData"
              @select="option => autocompleate(option)">
              
              <template slot="empty">No results found</template>
              
              <template slot-scope="props">
                <div class="media">
                  <div class="media-content">
                    {{ props.option.name }}
                    <br>
                    <small>
                      ИНН : {{ props.option.inn}}
                      КТП : {{ props.option.kpp}}
                      ОГРН : {{ props.option.ogrn}}
                    </small>
                  </div>
                </div>
              </template>
            </b-autocomplete>
            <p class="control">
              <button class="button is-danger" @click="clearCompany()">X</button>
            </p>
          </b-field>
        </b-field>
      </b-field>
    </section>
    <section class="uk-margin">
      <b-table
        :bordered="true"
        :hoverable="true"
        :data="data"
        :default-sort-direction="filters.sort">
        <template slot-scope="props" @click="click">
          <b-table-column field="id" label="ID" width="40" sortable numeric>
            {{ props.row.id }}
          </b-table-column>
          
          <b-table-column field="date" label="Дата регистрации" sortable>
            <!-- {{ props.row.date }} -->
            {{ moment(props.row.date).add(moment().utcOffset(), 'minute').format('YYYY-MM-DD HH:ss:mm') }}
          </b-table-column>

          <b-table-column field="name" label="Наименование" sortable>
            {{ props.row.name }}
          </b-table-column>
          
          <b-table-column field="address" label="Адрес" sortable>
            {{ props.row.address }}
          </b-table-column>

          <b-table-column field="email" label="Email" sortable>
            {{ props.row.email }}
          </b-table-column>

          <b-table-column field="orgn" label="ОГРН" sortable>
            {{ props.row.orgn }}
          </b-table-column>

          <b-table-column field="inn" label="ИНН" sortable>
            {{ props.row.inn }}
          </b-table-column>

          <b-table-column field="kpp" label="КПП" sortable>
            {{ props.row.kpp }}
          </b-table-column>

          <b-table-column field="is_active" label="Состояние" sortable>
            {{ humanState(props.row.is_active) }}
          </b-table-column>
          
          <b-table-column label="Действие" centered>
            <div class="block">
              <a href="#" @click="editRow(props.row.id)">
                <b-icon icon="pen" type="is-dark" size="is-small"></b-icon>
              </a>
            </div>
          </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                icon="sad-tear"
                size="is-large">
              </b-icon>
            </p>
            <p>Данных нет.</p>
          </div>
        </section>
      </template>
      </b-table>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
  </div>
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
import debounce from 'lodash/debounce'
import { companySearch } from '@/api'
import { EventBus } from '@/utils'
export default {
  name: "ClientsTable",
  data() {
    const data = []
    const async_data = []
    const states = [
      {
        id: true,
        name: "Активная"
      },
      {
        id: false,
        name: "Не активная"
      }
    ]
    const limits = [
      5, 10, 20, 25, 50, 75, 100
    ]
    return {
      data: data,
      async_data: async_data,
      states: states,
      //autocompleate
      isFetching: false,
      search_placeholder: 'Поиск компании по названию и т.д.',
      def_search_placeholder: 'Поиск компании по названию и т.д.',
      //pagination backend
      limits,
      currentPage: 1,
      total: 0,
      filters: {
        is_active: null,
        id: null,
        order: 'asc',
        limit: 25
      }
    }
  },
  mounted: function() {
    this.$store.dispatch('getCompanies')
      .then(response => {
        let data = response.data;
        this.total = data.total
        data.data.forEach((item) => {
          this.data.push(item)
        })
      })
      .catch(error => {
        this.data = []
      })
    
    EventBus.$on('successCreateCompany', (data) => {
      this.data.push(data)
    })

    EventBus.$on('failedCreateCompany', (msg) => {
      this.$toast.open({
        message: `${this.$i18n.t('admin.create_error')} ${msg}`,
        type: 'is-danger',
        position: 'is-bottom'
      })
    })

    EventBus.$on('successUpdateCompany', () => {
      $this.pageChange()
    })
  },
  beforeDestroy: function(){
    EventBus.$off('successCreateCompany')
    EventBus.$off('successUpdateCompany')
    EventBus.$off('failedCreateCompany')
  },
  methods: {
    add(item){
      EventBus.$emit("showModal", "company.add", null)
    },
    editRow(item){
      EventBus.$emit("showModal", "company.edit", item)
    },
    humanState: function(value){
      let name = this.states.filter(function(state) {
        return state.id === value;
      })
      .map(function(state) {
        return state.name;
      }); 
      if (name.length){
        return name[0]
      }
      else{
        return ""
      }
    },
    getAsyncData: debounce(function (search) {
      let $this = this
      if (!search.length) {
        this.async_data = []
        return
      }
      this.isFetching = true
      companySearch(search, $this.$store.state.jwt.token)
      .then(response => {
        let data = response.data.data;
        if (data.length){
          $this.async_data = []
          data.forEach((item) => $this.async_data.push(item))
        }
        else{
          $this.async_data = []
        }
      })
      .catch(error => {
        $this.async_data = []
      })
      .finally($this.isFetching = false)

    }, 500),
    autocompleate: function(option){
      this.filters.id = option.id
      this.search_placeholder = option.name
      this.pageChange()
    },
    clearCompany(){
      this.filters.id = null
      this.search_placeholder = this.def_search_placeholder
      this.pageChange()
    },
    pageChange(page){
      if(page){
        this.currentPage = page
      }
     
      this.$store.dispatch('getPageCompanies', { page: this.currentPage, filters: this.filters })
        .then(response => {
          let data = response.data;
          
          this.data = []
          this.total = data.total
          data.data.forEach((item) => {
            this.data.push(item)
          })

        })
        .catch(error => {
          this.data = []
        })
    }
  }
}
</script>